module.exports = __webpack_public_path__ + "static/media/doorClosed.97674cb8.mp3";